import { useWorkplaceStore } from '@/host/stores';
import { AppSettingsResponse } from '../types/AppSettings';
import { logger } from '../utils';
import { ApiService } from './api.service';
import { RoomOooMessageChangedEvent } from 'nexgen-types';
import { GlobalEventService } from '@/host/services/event.service';

export const RoomService = {
  updateOfficeData: async (message: string | null) => {
    try {
      const homeRoom = useWorkplaceStore.getState().homeRoom;

      await ApiService.patch(`office/floor/${homeRoom.floor_pid}/room/${homeRoom.pid}`, {
        ooo_message: message,
      });

      // Emit room OOO message changed event
      const currentUser = useWorkplaceStore.getState().user;
      const currentOrg = useWorkplaceStore.getState().org;

      const eventPayload = {
        room_pid: homeRoom.pid,
        floor_pid: homeRoom.floor_pid,
        ooo_message: message || '',
        user_pid: currentUser.pid,
        org_pid: currentOrg?.pid,
      };

      const roomOooMessageChangedEvent = RoomOooMessageChangedEvent.create(eventPayload);
      GlobalEventService.emitTyped(roomOooMessageChangedEvent, true);
    } catch (error) {
      logger(`Error updating office data: ${error}`);
    }
  },
  getAppSettings: async (): Promise<AppSettingsResponse | null> => {
    try {
      const appSettings = await ApiService.get<AppSettingsResponse>(
        `user-org-preferences/app-settings/office`
      );
      return appSettings;
    } catch (error) {
      logger(`Error fetching app settings: ${error}`);
      return null;
    }
  },
};
